/* eslint-disable id-length */

/**
 * svgs in this file are prefixed with the xml namespace (http://www.w3.org/2000/svg) so that they are properly rendered
 * by tiptap/prosemirror. Including them instructs the library to generate the element using `createElementNS` rather
 * than `createElement`.
 */

export const fileIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 12 12' },
    [
        'path',
        {
            d:
                'M7.25 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73478 2 2V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10V3.75L7.25 1Z',
        },
    ],
    ['path', { d: 'M7 1V4H10' }],
];

export const cursorIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 13 12' },
    ['path', { d: 'M3.46484 1.11646L4.89121 10.197L6.98506 6.90407L10.8721 6.55921L3.46484 1.11646Z' }],
    ['path', { d: 'M7.13867 7.15771L9.34342 10.7825' }],
];

export const usersIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 12 8' },
    [
        'path',
        {
            d:
                'M8 10.5V9.5C8 8.96957 7.78929 8.46086 7.41421 8.08579C7.03914 7.71071 6.53043 7.5 6 7.5H3C2.46957 7.5 1.96086 7.71071 1.58579 8.08579C1.21071 8.46086 1 8.96957 1 9.5V10.5',
        },
    ],
    [
        'path',
        {
            d:
                'M4.5 5.5C5.60457 5.5 6.5 4.60457 6.5 3.5C6.5 2.39543 5.60457 1.5 4.5 1.5C3.39543 1.5 2.5 2.39543 2.5 3.5C2.5 4.60457 3.39543 5.5 4.5 5.5Z',
        },
    ],
    [
        'path',
        {
            d:
                'M11 10.4999V9.49994C10.9997 9.05681 10.8522 8.62633 10.5807 8.2761C10.3092 7.92587 9.92906 7.67573 9.5 7.56494',
        },
    ],
    [
        'path',
        {
            d:
                'M8 1.56494C8.43021 1.67509 8.81152 1.92529 9.08382 2.2761C9.35612 2.6269 9.50392 3.05836 9.50392 3.50244C9.50392 3.94653 9.35612 4.37798 9.08382 4.72879C8.81152 5.07959 8.43021 5.32979 8 5.43994',
        },
    ],
];

export const zapIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 12 12' },
    [
        'path',
        {
            d: 'M6.5 1L1.5 7H6L5.5 11L10.5 5H6L6.5 1Z',
        },
    ],
];

export const pieChartIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 24 24' },
    [
        'path',
        {
            d: 'M21.21 15.89A10 10 0 1 1 8 2.83',
        },
    ],
    [
        'path',
        {
            d: 'M22 12A10 10 0 0 0 12 2v10z',
        },
    ],
];

export const userIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 24 18' },
    [
        'path',
        {
            d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2',
        },
    ],
    [
        'circle',
        {
            cx: '12',
            cy: '7',
            r: '4',
        },
    ],
];

export const appIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 24 24' },
    ['rect', { x: '2', y: '3', width: '20', height: '14', rx: '2', ry: '2' }],
    ['line', { x1: '8', y1: '21', x2: '16', y2: '21' }],
    ['line', { x1: '12', y1: '17', x2: '12', y2: '21' }],
];

export const gridIconSvg = [
    'http://www.w3.org/2000/svg svg',
    { width: '14', height: '14', viewBox: '0 0 24 24' },
    ['rect', { x: '3', y: '3', width: '7', height: '7' }],
    ['rect', { x: '14', y: '3', width: '7', height: '7' }],
    ['rect', { x: '14', y: '14', width: '7', height: '7' }],
    ['rect', { x: '3', y: '14', width: '7', height: '7' }],
];
